const getters = {
  getSpecialisations: state => state.specialisations,
  getInvoices: state => state.invoices,
  getClientsBankDetails: state => state.clientsBankDetails,
  getClientsBankDetailsAll: state => state.bankAllDetails.filter(item => item.ownership && item.ownership.ownership === 'client'),
  getBankDetails: state => state.bankDetails,
  getAllClients: state => state.allClients,
  getBusinessEntityTypes: state => state.businessEntityTypes,
  getBankDetailsSigns: state => state.bankDetailsSigns,
  getBankDetailsCards: state => state.bankDetailsCards,
  getOwnBankDetails: state => state.bankAllDetails.filter(item => item.ownership && item.ownership.ownership === 'own'),
  // getClientBankDetails: state => state.bankAllDetails.filter(item => item.ownership && item.ownership.ownership === 'client'),
  getPartnerBankDetails: state => state.bankAllDetails.filter(item => item.ownership && item.ownership.ownership === 'partner'),
  getContractorBankDetails: state => state.bankAllDetails.filter(item => item.ownership && item.ownership.ownership === 'contractor'),
  getClients: state => state.clients,
  getStatuses: state => state.statuses,
  getTemplates: state => state.templates,
  getInvoicesTypes: state => state.invoicesTypes,
  getPayouts: state => state.payouts,
  getPayoutsTypes: state => state.payoutsTypes,
  getPayoutsStatuses: state => state.payoutsStatuses,
  getPayoutsTemplateTypes: state => state.payoutsTemplateTypes,
  getInvoicesPeriodTypes: state => state.invoicesPeriodTypes,
  getExpenses: state => state.expenses,
  getIsModalLoading: state => state.isModalLoading,
  getTaxTypes: state => state.taxTypes,
  getSalesChannels: state => state.salesChannels,
  getIsShowAllFields: state => state.isShowAllFields
}

const actions = {
  setInvoices ({ commit }, data) {
    commit('setInvoices', data)
  },
  setInvoicesTypes ({ commit }, data) {
    commit('setInvoicesTypes', data)
  },
  setInvoicesStatuses ({ commit }, data) {
    commit('setInvoicesStatuses', data)
  },
  setInvoicesTemplates ({ commit }, data) {
    commit('setInvoicesTemplates', data)
  },
  setInvoicesPeriodTypes ({ commit }, data) {
    commit('setInvoicesPeriodTypes', data)
  },
  setPayouts ({ commit }, data) {
    commit('setPayouts', data)
  },
  setPayoutsTypes ({ commit }, data) {
    commit('setPayoutsTypes', data)
  },
  setPayoutsStatuses ({ commit }, data) {
    commit('setPayoutsStatuses', data)
  },
  setPayoutsTemplateTypes ({ commit }, data) {
    commit('setPayoutsTemplateTypes', data)
  },
  setExpenses ({ commit }, data) {
    commit('setExpenses', data)
  },
  setBusinessEntityTypes ({ commit }, data) {
    commit('setBusinessEntityTypes', data)
  },
  setBankAllDetails ({ commit }, data) {
    commit('setBankAllDetails', data)
  },
  setAllClients ({ commit }, data) {
    commit('setAllClients', data)
  },
  setSpecialisations ({ commit }, data) {
    commit('setSpecialisations', data)
  },
  addSpecialisation ({ commit }, data) {
    commit('addSpecialisation', data)
  },
  removeSpecialisation ({ commit }, data) {
    commit('removeSpecialisation', data)
  },
  editSpecialisation ({ commit }, data) {
    commit('editSpecialisation', data)
  },

  setBankDetails ({ commit }, data) {
    commit('setBankDetails', data)
  },
  setBankDetailsCards ({ commit }, data) {
    commit('setBankDetailsCards', data)
  },
  addBankDetailsCards ({ commit }, data) {
    commit('addBankDetailsCards', data)
  },
  removeBankDetailsCards ({ commit }, data) {
    commit('removeBankDetailsCards', data)
  },
  editBankDetailsCards ({ commit }, data) {
    commit('editBankDetailsCards', data)
  },
  setClientsBankDetails ({ commit }, data) {
    commit('setClientsBankDetails', data)
  },
  setClientsBankDetailsAll ({ commit }, data) {
    commit('setClientsBankDetailsAll', data)
  },
  setClients ({ commit }, data) {
    commit('setClients', data)
  },
  setBankDetailsSigns ({ commit }, data) {
    commit('setBankDetailsSigns', data)
  },
  setIsModalLoading ({ commit }, val) {
    commit('setIsModalLoading', val)
  },

  setTaxTypes ({ commit }, data) {
    commit('setTaxTypes', data)
  },
  addTaxType ({ commit }, data) {
    commit('addTaxType', data)
  },
  editTaxType ({ commit }, data) {
    commit('editTaxType', data)
  },
  removeTaxType ({ commit }, data) {
    commit('removeTaxType', data)
  },

  setSalesChannels ({ commit }, data) {
    commit('setSalesChannels', data)
  },
  addSalesChannel ({ commit }, data) {
    commit('addSalesChannel', data)
  },
  editSalesChannel ({ commit }, data) {
    commit('editSalesChannel', data)
  },
  removeSalesChannel ({ commit }, data) {
    commit('removeSalesChannel', data)
  },
  setIsShowAllFields ({ commit }, value) {
    commit('setIsShowAllFields', value)
  }
}

const mutations = {
  setInvoices (state, data) {
    state.invoices = data
  },

  setInvoicesStatuses (state, data) {
    state.statuses = data
  },
  setInvoicesPeriodTypes (state, data) {
    state.invoicesPeriodTypes = data
  },
  setInvoicesTypes (state, data) {
    state.invoicesTypes = data
  },
  setInvoicesTemplates (state, data) {
    state.templates = data
  },
  setPayoutsTypes (state, data) {
    state.payoutsTypes = data
  },
  setPayouts (state, data) {
    state.payouts = data
  },
  setPayoutsStatuses (state, data) {
    state.payoutsStatuses = data
  },
  setPayoutsTemplateTypes (state, data) {
    state.payoutsTemplateTypes = data
  },
  setExpenses (state, data) {
    state.expenses = data
  },
  setAllClients (state, data) {
    state.allClients = data.map(item => {
      return {
        ...item,
        full_name: `${item.first_name} ${item.last_name}`
      }
    })
  },
  setClients (state, data) {
    state.clients = data
  },
  setBankAllDetails (state, data) {
    state.bankAllDetails = data
  },
  setBusinessEntityTypes (state, data) {
    state.businessEntityTypes = data
  },
  setSpecialisations (state, data) {
    state.specialisations = data
  },
  addSpecialisation (state, data) {
    state.specialisations.push(data)
  },
  removeSpecialisation (state, id) {
    state.specialisations = state.specialisations.filter(
      item => item.id !== id
    )
  },
  editSpecialisation (state, data) {
    state.specialisations.some(item => {
      if (item.id === data.id) {
        Object.assign(item, data)
        return true
      }
    })
  },

  setClientsBankDetails (state, data) {
    state.clientsBankDetails = data
  },

  setClientsBankDetailsAll (state, data) {
    state.clientsBankDetailsAll = data
  },

  setBankDetails (state, data) {
    state.bankDetails = data
  },
  setBankDetailsCards (state, data) {
    state.bankDetailsCards = data
  },
  addBankDetailsCards (state, data) {
    state.bankDetailsCards.push(data)
  },
  removeBankDetailsCards (state, id) {
    state.bankDetailsCards = state.bankDetailsCards.filter(
      item => item.id !== id
    )
  },
  editBankDetailsCards (state, data) {
    state.bankDetailsCards.some(item => {
      if (item.id === data.id) {
        Object.assign(item, data)
        return true
      }
    })
  },
  setBankDetailsSigns (state, data) {
    state.bankDetailsSigns = data
  },
  setIsModalLoading (state, val) {
    state.isModalLoading = val
  },

  setTaxTypes (state, data) {
    state.taxTypes = data
  },
  addTaxType (state, data) {
    state.taxTypes.push(data)
  },
  editTaxType (state, data) {
    state.taxTypes.some(item => {
      if (item.id === data.id) {
        Object.assign(item, data)
        return true
      }
    })
  },
  removeTaxType (state, id) {
    state.taxTypes = state.taxTypes.filter(item => item.id !== id)
  },

  setSalesChannels (state, data) {
    state.salesChannels = data
  },
  addSalesChannel (state, data) {
    state.salesChannels.push(data)
  },
  editSalesChannel (state, data) {
    state.salesChannels.some(item => {
      if (item.id === data.id) {
        Object.assign(item, data)
        return true
      }
    })
  },
  removeSalesChannel (state, id) {
    state.salesChannels = state.salesChannels.filter(item => item.id !== id)
  },
  setIsShowAllFields (state, value) {
    state.isShowAllFields = value
  }
}

const state = {
  specialisations: [],
  invoices: {},
  invoicesTypes: [],
  payouts: [],
  payoutsTypes: [],
  payoutsStatuses: [],
  payoutsTemplateTypes: [],
  expenses: [],
  clientsBankDetails: {},
  clientsBankDetailsAll: {},
  bankDetails: {},
  bankDetailsSigns: [],
  bankDetailsCards: {},
  clients: {},
  allClients: [],
  businessEntityTypes: [],
  bankAllDetails: [],
  statuses: [],
  templates: [],
  invoicesPeriodTypes: [],
  isModalLoading: false,
  taxTypes: [],
  salesChannels: [],
  isShowAllFields: false
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
